export const uploadCourseReport = (payload?: any) => ({
    type: "@saga/UPLOAD_COURSE_REPORT",
    payload
});

